<template>
  <div class="modal-cashier">
    <div class="cashier-header">
      <!-- DEPOSIT TAB -->
      <button
        @click="modalSetTab('deposit')"
        class="button-nav"
        :class="{ 'button-active': modalTab === 'deposit' }"
      >
        <div class="button-inner">
          <span>{{ $t('modal.25') }}</span>
        </div>
      </button>

      <!-- WITHDRAW TAB -->
      <button
        @click="modalSetTab('withdraw')"
        class="button-nav"
        :class="{ 'button-active': modalTab === 'withdraw' }"
      >
        <div class="button-inner">
          <span>{{ $t('modal.26') }}</span>
        </div>
      </button>

      <!-- TIP TAB -->
      <button
        @click="modalSetTab('tip')"
        class="button-nav"
        :class="{ 'button-active': modalTab === 'tip' }"
      >
        <div class="button-inner">
          <span>{{ $t('modal.tip') }}</span>
        </div>
      </button>
    </div>

    <!-- ================= DEPOSIT ================= -->
    <div v-if="modalTab === 'deposit'">
      <CashierDeposit
        v-if="depositStep === 'options'"
        @select-crypto="depositStep = 'crypto'"
      />

      <DepositCryptoModal
        v-else
        @close="depositStep = 'options'"
      />
    </div>

    <!-- ================= WITHDRAW ================= -->
    <div v-else-if="modalTab === 'withdraw'">
      <CashierWithdraw
        v-if="withdrawStep === 'options'"
        @select-crypto="onWithdrawSelectCrypto"
      />

      <CashierCryptoWithdraw
        v-else
        :currency="selectedWithdrawCurrency"
        @close="withdrawStep = 'options'"
      />
    </div>

    <!-- ================= TIP ================= -->
    <ModalTip v-else />
  </div>
</template>



<script>
import { mapGetters } from 'vuex'

import CashierDeposit from '@/components/modals/DepositOptionsModal'
import DepositCryptoModal from '@/components/modals/DepositCryptoModal'

import CashierWithdraw from '@/components/cashier/CashierWithdraw'
import CashierCryptoWithdraw from '@/components/cashier/CashierCryptoWithdraw'

import ModalTip from '@/components/modals/ModalTip'

export default {
  name: 'ModalCashier',

  components: {
    CashierDeposit,
    DepositCryptoModal,
    CashierWithdraw,
    CashierCryptoWithdraw,
    ModalTip
  },

  data() {
    return {
      modalTab: 'deposit',

      depositStep: 'options',
      withdrawStep: 'options',

      selectedWithdrawCurrency: null
    }
  },

  computed: {
    ...mapGetters([
      'modalsData'
    ])
  },

  methods: {
    modalSetTab(tab) {
      this.modalTab = tab

      if (tab === 'deposit') {
        this.depositStep = 'options'
      }

      if (tab === 'withdraw') {
        this.withdrawStep = 'options'
        this.selectedWithdrawCurrency = null
      }
    },

    onWithdrawSelectCrypto() {
  this.selectedWithdrawCurrency = null
  this.withdrawStep = 'crypto'
}

  },

  created() {
    if (
      this.modalsData &&
      ['deposit', 'withdraw', 'tip'].includes(this.modalsData.typeCashier)
    ) {
      this.modalTab = this.modalsData.typeCashier
    }
  }
}
</script>



<style scoped>
.modal-cashier {
    width: 820px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 25px 35px 40px 35px;
    border-radius: 15px;
    background: var(--background3);
}

/* Header */
.modal-cashier .cashier-header {
    width: 100%;
    display: flex;
    align-items: center;
    padding-bottom: 25px;
    border-bottom: 1px solid #335361;
}

/* Nav buttons */
.modal-cashier button.button-nav {
    height: 54px;
    position: relative;
    margin-right: 15px;
    padding: 1px;
    transition: all 0.3s ease;
    width: 100%;
}
.modal-cashier button.button-nav:last-of-type {
    margin-right: 0;
}
.modal-cashier button.button-nav .button-inner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    background: var(--background2);
    border-radius: 12px;
    color: #fff;
}
.modal-cashier button.button-nav.button-active .button-inner {
    background: var(--buttonyellow);
    box-shadow: var(--buttonyellowbox);
    color: #fff; 
    padding: 4px 8px;
    border-radius: 12px;
    text-shadow: -1px -1px 0 var(--roo-btn-text-stroke-color, #C56A18), 
                 1px -1px 0 var(--roo-btn-text-stroke-color, #C56A18), 
                 -1px 1px 0 var(--roo-btn-text-stroke-color, #C56A18), 
                 1px 1px 0 var(--roo-btn-text-stroke-color, #C56A18);
}
.modal-cashier button.button-nav .button-inner svg {
    margin-right: 8px;
    fill: #fff;
}
.modal-cashier button.button-nav.button-active .button-inner svg {
    fill: #ffffff;
}
.modal-cashier button.button-nav .button-inner span {
    font-size: 14px;
    font-weight: bold;
    font-family: "Montserrat", Arial, "Segoe UI", Helvetica, sans-serif;
}

/* Tablet */
@media only screen and (max-width: 840px) {
    .modal-cashier {
        width: calc(100vw - 20px);
        padding: 25px 20px 40px 20px;
    }
}

/* Mobil */
@media only screen and (max-width: 500px) {
    .modal-cashier {
        width: 100vw;              /* Tam genişlik */
        max-width: 100%;           /* Taşma engelle */
        border-radius: 20px 20px 0 0; /* Sadece üst köşeler yuvarlak */
        padding: 75px 20px 40px 20px;
    }

    .modal-cashier .cashier-header {
        justify-content: center;
    }
}
</style>

